"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ClientMarkdownParsingComponent: ()=>ClientMarkdownParsingComponent
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_TravelBotLogoImage_js_namespaceObject = require("../../TravelBotLogoImage.js");
const MessageFooter_js_namespaceObject = require("../MessageFooter/MessageFooter.js");
var MessageFooter_js_default = /*#__PURE__*/ __webpack_require__.n(MessageFooter_js_namespaceObject);
const external_CustomMarkdown_js_namespaceObject = require("./CustomMarkdown.js");
const CitationsSources_js_namespaceObject = require("../MetadataMarker/CitationsSources.js");
const sanitizeText_js_namespaceObject = require("../../utils/sanitizeText.js");
const ClientMarkdownParsingComponent = (props)=>{
    const { finalTexts, webSearchResult } = props;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
        mb: 4,
        variation: "initial",
        Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
        message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CustomMarkdown_js_namespaceObject.CustomMarkdown, {
                    children: (0, sanitizeText_js_namespaceObject.sanitizeText)(finalTexts)
                }),
                webSearchResult?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CitationsSources_js_namespaceObject.CitationsSources, {
                    citationsMeta: [],
                    webSearchResult: webSearchResult
                })
            ]
        }),
        footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {})
    });
};
exports.ClientMarkdownParsingComponent = __webpack_exports__.ClientMarkdownParsingComponent;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ClientMarkdownParsingComponent"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
